import React from "react";
import Component from "../../Components";
import "./NurseRequest.css";

const ServiceDetails = () => {
  return (
    <div className="mng-nurse-req">
      <Component.ServiceDetails />
    </div>
  );
};

export default ServiceDetails;
